import { AxiosPromise } from "axios";
import { HttpClient } from "../../../shared/api/httpClient";
import { API_ENDPOINT } from "../../../shared/constanst/constants";

const API_SLUG = 'Facturas';

// interface RequestExpatriados{
// 	IdSociedad: string;
// 	FechaDesde
// }

export class FacturasAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

    Facturar(data:any): AxiosPromise<any> {
		return this.cliente.post(data, `/Facturar`);
	}

	InformeFacturacionPorProvincia(data:any): AxiosPromise<Blob> {
		return this.cliente.postDownloadFile(data, `/InformeFacturacionPorProvincia`);
	}

	// GenerarFacturacionExpatriados_old(data: any): AxiosPromise<any>{
	// 	return this.cliente.post(data, `/FacturacionExpatriados`)
	// }

	GenerarFacturacionExpatriados(data: any,file:File): AxiosPromise<any>{
		var formData = new FormData();

		formData.append("Request", JSON.stringify(data))
		formData.append("File", file);

		return this.cliente.postFile(formData,`/FacturacionExpatriados`)
	}

	GenerarFacturaExpatriadosAs400(idFactura: string, tipoSociedad:string): AxiosPromise<any>{
		return this.cliente.get(`/FacturacionExpatriados/GenerarFicherosAS400/${tipoSociedad}/${idFactura}`)
	}

	FacturacionExpatriadosPorSociedad(data: any): AxiosPromise<any>{
		return this.cliente.post(data, `/FacturacionExpatriados/Sociedad`)
	}

	FacturacionExpatriadosPorDn(data: any): AxiosPromise<any>{
		return this.cliente.post(data, `/FacturacionExpatriados/Dn`)
	}

	FacturacionExpatriadosPorUsuario(data: any): AxiosPromise<any>{
		return this.cliente.post(data, `/FacturacionExpatriados/Usuario`)
	}

	FacturacionExpatriadosPorGrupoFactura(data: any): AxiosPromise<any>{
		return this.cliente.post(data, `/FacturacionExpatriados/grupoFactura`)
	}

	ListarHistoricoFacturacionExpatriados(data:any): AxiosPromise<any>{
		return this.cliente.post(data,`/FacturacionExpatriados/ListarHistorico`)
	}

	GetHistoricoFacturacionExpatriados(data:string): AxiosPromise<any>{
		return this.cliente.post(data,`/FacturacionExpatriados/GetHistorico`)
	}

	GenerarHistoricoBS64(data:any): AxiosPromise<any>{
		var formData = new FormData();

		formData.append("IdFactura", data.idFactura)
		formData.append("File", data.fichero);

		return this.cliente.postFile(formData,`/FacturacionExpatriados/GenerarHistorico`)
	}

	// GenerarHistoricoBS64Copia(): AxiosPromise<any>{
	// 	return this.cliente.get(`/FacturacionExpatriados/GenerarHistoricoCopia`)
	// }

	getUsuariosExpatriadosInfo(data:any): AxiosPromise<any>{
		return this.cliente.post(data,`/FacturacionExpatriados/GetUsuariosInfo`)
	}

	ListarEjerciciosFacturacionExpatriados(): AxiosPromise<any>{
		return this.cliente.get(`/FacturacionExpatriados/GetEjercicios`)
	}
}